import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import {
	FractionTransfer,
	FractionsListResponse,
	ProfitCapitalizationCreatePayload,
	RaiseRatioResponse,
	TransferRequestPayload,
} from '../models/profitCapitalization';
import { TranslatedField } from 'core/models/common';

export const onCheckDateFields = async () => {
	try {
		const response = await axios.get<JsonResponse<{ hide_date_fields: boolean }>>(
			'dashboard/actions/raise-capital/profit-capitalization-hide-date-fields',
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckEligibilityDate = async (eligibility_date: string) => {
	try {
		const response = await axios.post<JsonResponse<{ isValidEligibilityDate: boolean }>>('dashboard/actions/raise-capital/check-eligibility-date', {
			eligibility_date,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckCapitalRaiseRatio = async (payload: { eligibility_date: string; capital_raise_ratio: number }) => {
	try {
		const response = await axios.post<JsonResponse<{ ratioResult: RaiseRatioResponse }>>(
			'dashboard/actions/raise-capital/check-capital-raise-ratio',
			payload,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckCapitalRaiseByUnits = async (payload: { eligibility_date: string; number_of_issued_units: number }) => {
	try {
		const response = await axios.post<JsonResponse<{ ratioResult: RaiseRatioResponse }>>(
			'dashboard/actions/raise-capital/check-capital-raise-by-units',
			payload,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateProfitCapitalization = async (payload: ProfitCapitalizationCreatePayload) => {
	try {
		const response = await axios.post<JsonResponse<{ ratioResult: RaiseRatioResponse }>>(
			'dashboard/actions/raise-capital/profit-capitalization',
			payload,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateProfitCapitalization = async (id: string, payload: ProfitCapitalizationCreatePayload) => {
	try {
		const response = await axios.put<JsonResponse<{ ratioResult: RaiseRatioResponse }>>(
			`dashboard/actions/raise-capital/profit-capitalization/${id}`,
			payload,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetProfitCapitalizationFractions = async (id: number, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<FractionsListResponse>>(
			`dashboard/actions/raise-capital/profit-capitalization-fractions/${id}?page=${page}`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onExportProfitCapitalizationFractions = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<{ excel_file_path: string }>>(`dashboard/actions/raise-capital/export-fractions-to-excel/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckShareholderForProfitCapitalization = async (national_id: string) => {
	try {
		const response = await axios.post<JsonResponse<{ exists: true; name: TranslatedField }>>(`dashboard/actions/raise-capital/check-investor`, {
			national_id,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckFractionTransfer = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<FractionTransfer>>(`dashboard/actions/raise-capital/is-fraction-transfer-available/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onMakeTransferRequest = async (payload: TransferRequestPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/raise-capital/make-transfer-request`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
